export const POSITION_OPTIONS = [
  {
    key: 'developer',
    value: '개발자',
  },
  {
    key: 'ai-data',
    value: 'AI • 데이터 전문가'
  },
  {
    key: 'designer',
    value: '디자이너',
  },
  {
    key: 'marketer',
    value: '마케터 • 세일즈',
  },
  {
    key: 'engineer',
    value: '하드웨어 엔지니어',
  },
  {
    key: 'product-manager',
    value: '설계 / 기획 / 관리',
  },
  {
    key: 'operator',
    value: 'CS • 오퍼레이터',
  },
  {
    key: 'finance',
    value: '재무 • IR/투자 전문가',
  },
];

export const POSITION_OPTION_DICT = Object.assign({}, ...POSITION_OPTIONS.map((x) => ({[x.key]: x.value})));

export const NORMAL_FEE_RATE = 10;
export const TRIAL_FEE_RATE = 18;
export const LONGTERM_FEE_RATE = 8;
export const RESIENDT_FEE_RATE = 20;
